<template>
  <component :is="layout">
    <router-view></router-view>
  </component>
</template>

<script>
const default_layout = "page"
export default {
  computed: {
    layout() {
      return `${(this.$route.meta.layout || default_layout)}-layout`
    }
  },
  watch: {
    '$route' (to, from) {
      document.title = 'meta' in to ? `${to.meta.title} | Sky` : `Sky`
    }
  },
  mounted() {
    // Set up periodic WebSocket connection check
    this.connectionCheckInterval = setInterval(() => {
      this.checkWebSocketConnection()
    }, 30000) // Check every 30 seconds

    // Initial connection check after mount
    setTimeout(() => {
      this.ensureWebSocketConnection()
    }, 2000)

    // Listen for page visibility changes to reconnect when tab becomes active
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

    // Listen for online/offline events
    window.addEventListener('online', this.handleOnline)
    window.addEventListener('offline', this.handleOffline)
  },
  beforeDestroy() {
    // Clean up intervals and listeners
    if (this.connectionCheckInterval) {
      clearInterval(this.connectionCheckInterval)
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('online', this.handleOnline)
    window.removeEventListener('offline', this.handleOffline)
  },
  methods: {
    handleVisibilityChange() {
      if (!document.hidden && this.user) {
        // Page became visible, ensure WebSocket is connected
        setTimeout(() => {
          this.ensureWebSocketConnection()
        }, 1000)
      }
    },
    handleOnline() {
      setTimeout(() => {
        this.ensureWebSocketConnection()
      }, 2000)
    },
    handleOffline() {
      // Could show offline indicator here
    }
  }
}
</script>
